module.exports = __webpack_public_path__ + "static/media/throwknife.4d089d23.mp3";